import { SearchUser, User } from 'lib-shared-types-api';

export function transformSearchUserToUser(user: SearchUser): User {
  return {
    additional_emails: [...(user.additional_emails ?? [])],
    additional_phone_numbers: [...(user.additional_phone_numbers ?? [])],
    anonymized_at: user.anonymized_at ?? null,
    avatar_url: user.avatar_url ?? null,
    company_id: user.company_id ?? null,
    default_outbound_number: null,
    email: user.email ?? null,
    external_id: null,
    family_name: null,
    given_name: null,
    has_scim_enabled: false,
    id: user.id,
    is_banned_hack: null,
    name: user.display_name ?? null,
    org_id: user.organization_id,
    phone_number: user.phone_number ?? null,
    skills: null,
    type: user.user_type ?? 'contact',
  };
}
